import { render, staticRenderFns } from "./BlacklistIndex.vue?vue&type=template&id=28c5754a&scoped=true&"
import script from "./BlacklistIndex.vue?vue&type=script&lang=js&"
export * from "./BlacklistIndex.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistIndex.vue?vue&type=style&index=0&id=28c5754a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5754a",
  null
  
)

export default component.exports